// import {FunctionExecRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/FunctionExecRequest';
import {FunctionResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/FunctionResponse';
import {FunctionsResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/FunctionsResponse';
import {API} from '@mintdata-wsp/common/controllers/network/WorkspaceAPI';
// import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {IFunctionContainer} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/ClientFunction';
import {Function, Param} from '@mintdata/mint-kit/api/decorators/Function';
import {
    FormulaKind,
    ISheetAPI,
    ISheetLocation,
    ISheetRangeIterator,
    ISheetRangeList,
    SheetType
} from '@mintdata/mint-kit/api/functions/SheetAPI';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {AError} from '@mintdata/mint-kit/api/values/AError';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {EvalErrors} from '@mintdata/mint-kit/api/values/errors/EvalErrors';
import {AFrame} from '@mintdata/mint-kit/api/values/frames/AFrame';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import {CoercionUtils} from '@mintdata/mint-kit/impl/coercionUtils/CoercionUtils';

export class TestFunctions implements IFunctionContainer
{
    public get namespace()
    {
        return 'test';
    }

    @Function({
        title: 'FORMULATEXT(reference)',
        alias: 'FORMULATEXT',
        example: 'FORMULATEXT(A1)',
        tip: 'Returns a formula as a string',
        icon: '',
        returns:
            {
                type: SheetType.AnyIValue,
                title: 'result',
                tip: 'Formula as a string'
            }
    })
    public async formulaText(@Param({
        title: 'api',
        tip: 'api',
        type: SheetType.SheetAPI,
    }) api:ISheetAPI, @Param({
        title: 'reference',
        tip: 'A reference to a cell or range of cells.',
        optional: false,
        type: SheetType.SheetLocation,
    }) reference:ISheetLocation, @Param({
        title: 'formula kind',
        tip: 'Formula kind: A1 or RC. Default value is A1',
        optional: true,
        type: Type.String,
    }) formulaKind?:AString):Promise<AString | AError>
    {
        const formulaKindValue = TestFunctions._getFormulaKind(formulaKind);

        //console.debug(`formulaText: ${reference}`, reference);
        const formulaText = api.getSheetContext().getCellFormulaText(reference, formulaKindValue);

        //console.debug(`formulaText: ${reference} => `, formulaText);

        return Promise.resolve(AString.fromString(formulaText));
    }

    @Function({
        title: 'FORMULAEVAL(formulaText)',
        alias: 'FORMULAEVAL',
        example: 'FORMULAEVAL("= A1 + 2")',
        tip: 'Evaluates value from a formula text',
        icon: '',
        returns:
            {
                type: SheetType.AnyIValue,
                title: 'result',
                tip: 'Evaluation value'
            }
    })
    public async evalFormula(@Param({
        title: 'api',
        tip: 'api',
        type: SheetType.SheetAPI
    }) api:ISheetAPI, @Param({
        title: 'formulaText',
        tip: 'Formula text',
        optional: false,
        type: Type.String
    }) formulaText:AString, @Param({
        title: 'formula kind',
        tip: 'Formula kind: A1 or RC. Default value is A1',
        optional: true,
        type: Type.String,
    }) formulaKind?:AString, @Param({
        title: 'named arguments',
        tip: 'Frame with two columns: name of argument name and value of argument. ',
        optional: true,
        type: Type.Frame,
    }) namedArguments?:AFrame):Promise<IValue | AError>
    {

        const argumentsMap = TestFunctions._getArgumentsMap(namedArguments);
        const formulaKindValue = TestFunctions._getFormulaKind(formulaKind);

        //console.error(`evalFormula: ${formulaText.value}`, formulaKindValue, argumentsMap);
        const evalResult = await api.getSheetContext()
            .evalFormula(formulaText.value, formulaKindValue, argumentsMap, true);

        //console.error(`evalFormula: ${formulaText.value} => `, evalResult);

        return Promise.resolve(evalResult);
    }

    private static _getFormulaKind(formulaKind?:AString)
    {
        if( formulaKind && formulaKind.value.toUpperCase() == FormulaKind._RC.value.toUpperCase() )
            return FormulaKind.RC();

        return FormulaKind.A1();
    }

    private static _getArgumentsMap(namedArguments:AFrame)
    {
        const argumentsMap = new Map<string, IValue>();

        if( namedArguments && namedArguments.fieldCount == 2 )
        {
            namedArguments.getRecords().forEach(value =>
            {
                const cells = value.getCells();

                const key = CoercionUtils.coerce(cells[0], Type.String, null) as AString;
                if( key )
                {
                    argumentsMap.set(key.value.toUpperCase(), cells[1]);
                }
            });
        }

        return argumentsMap;
    }

    private static async _execCloudFunction(functionName:AString, parameters:IFrame, timeoutMillis?:ANumber):Promise<IFrame | AError>
    {
        console.log(`execCloudFunction:`, functionName, parameters, timeoutMillis);

        try
        {
            // const design = commonControllers.designState.getOpenDesign().designRef;
            // const functions = await API.functions.list(design.designId);
            //
            // const cloudFunction = TestFunctions._findFunction(functions, functionName.value);
            // console.log(`execCloudFunction:`, cloudFunction);
            //
            // if( !cloudFunction )
            //     return EvalErrors.FunctionName;
            //
            // const functionExecRequest = new FunctionExecRequest(
            //     cloudFunction.id,
            //     IdUtil.newGUID(),
            //     parameters,
            //     (timeoutMillis) ? timeoutMillis.value : null
            // );
            //
            // console.log(`execCloudFunction:`, functionExecRequest);
            //
            // const response = await API.functions.exec(design.designId, cloudFunction.id, functionExecRequest);
            // console.log(`execCloudFunction:`, response);
            //
            // const responseResult = response as {success:boolean, result:any, errorMessage:string};
            // console.log(`execCloudFunction:`, responseResult);
            //
            // if( !responseResult )
            //     return Frames.empty();
            //
            // if( responseResult.success )
            // {
            //     if( responseResult.result )
            //     {
            //         try
            //         {
            //             return Frames.fromJSONObject(responseResult.result);
            //         }
            //         catch( e )
            //         {
            //             console.warn(`execCloudFunction:`, e);
            //             return JsonUtil.convertJsonObjectToFrame(responseResult.result);
            //         }
            //     }
            //
            //     return Frames.empty();
            // }
            // else
            // {
            //     if( responseResult.errorMessage )
            //         return AError.fromString(responseResult.errorMessage);
            //
            //     return EvalErrors.Data;
            // }
        }
        catch( e )
        {
            console.error(`execCloudFunction:`, e);
            return EvalErrors.Data;
        }
    }

    private static _findFunction(functions:FunctionsResponse, functionName:string):FunctionResponse | null
    {
        if( functions && functions.functions )
            return functions.functions.find(value => value.name.toLowerCase() == functionName.toLowerCase());

        return null;
    }

    @Function({
        title: 'print_ranges(ranges)',
        alias: 'PRINT_RANGES',
        example: 'PRINT_RANGES(A1:A2, 2:2)',
        tip: 'Prints ranges',
        icon: '',
        returns:
            {
                type: Type.String,
                title: 'result',
                tip: 'Ranges'
            }
    })
    public printRanges(@Param({
        title: 'range',
        tip: 'range',
        repeatable: true,
        type: SheetType.SheetRangeList
    }) args:ISheetRangeList[]):AString
    {
        let result:string = '';

        for( let i = 0; i < args.length; i++ )
        {
            if( result.length > 0 )
                result += ', ';

            result += args[i].ranges.join(' | ');
        }

        return AString.fromString(result);
    }

    @Function({
        title: 'print_cells(ranges)',
        alias: 'PRINT_CELLS',
        example: 'PRINT_CELLS(A1:A2, 2:2)',
        tip: 'Prints cell locations for a specified ranges',
        icon: '',
        returns:
            {
                type: Type.String,
                title: 'result',
                tip: 'Cell locations'
            }
    })
    public printCells(@Param({
                          title: 'sheetAPI',
                          tip: 'API',
                          type: SheetType.SheetAPI
                      })
                          api:ISheetAPI,
                      @Param({
                          title: 'range',
                          tip: 'range',
                          repeatable: true,
                          type: SheetType.SheetRangeList
                      }) args:ISheetRangeList[]):AString
    {
        let result:string = '';

        for( let i = 0; i < args.length; i++ )
        {
            if( result.length > 0 )
                result += ', ';

            const sheetRanges = args[i].ranges;
            for( let j = 0; j < sheetRanges.length; j++ )
            {
                if( j > 0 )
                    result += ' | ';

                const sheetRange = sheetRanges[j];
                const rangeIterator = api.getSheetContext().getRangeIterator(sheetRange);

                if( Math.abs(sheetRange.from.columnIndex - sheetRange.to.columnIndex) > Math.abs(sheetRange.from.rowIndex - sheetRange.to.rowIndex) )
                    result += TestFunctions._printCellLocationsByRows(rangeIterator, ' | ');
                else
                    result += TestFunctions._printCellLocationsByColumns(rangeIterator, ' | ');
            }
        }

        return AString.fromString(result);
    }

    private static _printCellLocationsByRows(rangeIterator:ISheetRangeIterator, separator:string)
    {
        let result:string = '';

        let rowIndex:number = -1;
        let prevSheetLocation:ISheetLocation = null;

        for( let i = 0; i < rangeIterator.numCells; i++ )
        {
            const sheetLocation:ISheetLocation = rangeIterator.getNthCellLocation(i);

            if( rowIndex != sheetLocation.rowIndex )
            {
                if( prevSheetLocation )
                {
                    result += `...${prevSheetLocation}`;
                }

                if( result.length > 0 )
                    result += separator;

                result += `${sheetLocation}`;

                rowIndex = sheetLocation.rowIndex;
            }

            prevSheetLocation = sheetLocation;
        }

        if( prevSheetLocation && rangeIterator.numCells > 1 )
        {
            result += `...${prevSheetLocation}`;
        }

        return result;
    }

    private static _printCellLocationsByColumns(rangeIterator:ISheetRangeIterator, separator:string)
    {
        let result:string = '';

        let columnIndex:number = -1;
        let prevSheetLocation:ISheetLocation = null;

        for( let i = 0; i < rangeIterator.numCells; i++ )
        {
            const sheetLocation:ISheetLocation = rangeIterator.getNthCellLocation(i);

            if( columnIndex != sheetLocation.columnIndex )
            {
                if( prevSheetLocation )
                {
                    result += `...${prevSheetLocation}`;
                }

                if( result.length > 0 )
                    result += separator;

                result += `${sheetLocation}`;

                columnIndex = sheetLocation.columnIndex;
            }

            prevSheetLocation = sheetLocation;
        }

        if( prevSheetLocation && rangeIterator.numCells > 1 )
        {
            result += `...${prevSheetLocation}`;
        }

        return result;
    }
}
